import {call, put, takeLatest} from "redux-saga/effects";
import {
  storeCustomFieldChoices,
  storeCustomFieldChoicesLabelValue,
  storeCustomFields,
  storeFieldTypes,
  storeObjectTypes,
  storeRelatedObjectTypes,
} from "../Actions/customFields.actions";
import {
  createUpdateCustomFieldsAsync,
  createUpdateCustomFieldChoicesAsync,
  deleteCustomFieldAsync,
  deleteCustomFieldChoiceAsync,
  getCustomFieldsAsync,
  getCustomFieldChoicesAsync,
  getCustomFieldChoicesLabelValueAsync,
  getFieldTypesAsync,
  getObjectTypesAsync,
  getRelatedObjectTypesAsync,
} from "../AsyncActions/customFields.async";
import * as actions from "../action.constants";

function* getCustomFields(action = {}) {
  const {pageUrl} = action;
  try {
    const response = yield call(getCustomFieldsAsync, pageUrl);
    if (response) {
      yield put(storeCustomFields(response.data));
    }
  } catch (e) {
    //
  }
}

function* createUpdateCustomField(action = {}) {
  const {payload, callback = () => {}} = action;

  try {
    const response = yield call(createUpdateCustomFieldsAsync, payload);
    if (response) {
      callback();
      yield call(getCustomFields);
    }
  } catch (e) {
    //
  }
}

function* deleteCustomField(action = {}) {
  const {id, callback = () => {}} = action;

  try {
    const response = yield call(deleteCustomFieldAsync, id);
    if (response) {
      callback();
      yield call(getCustomFields);
    }
  } catch (e) {
    //
  }
}

function* getCustomFieldChoices(action = {}) {
  const {pageUrl} = action;
  try {
    const response = yield call(getCustomFieldChoicesAsync, pageUrl);
    if (response) {
      yield put(storeCustomFieldChoices(response.data));
    }
  } catch (e) {
    //
  }
}

function* createUpdateCustomFieldChoice(action = {}) {
  const {payload, callback = () => {}} = action;

  try {
    const response = yield call(createUpdateCustomFieldChoicesAsync, payload);
    if (response) {
      callback();
      yield call(getCustomFieldChoices);
    }
  } catch (e) {
    //
  }
}

function* deleteCustomFieldChoice(action = {}) {
  const {id, callback = () => {}} = action;

  try {
    const response = yield call(deleteCustomFieldChoiceAsync, id);
    if (response) {
      callback();
      yield call(getCustomFieldChoices);
    }
  } catch (e) {
    //
  }
}

function* getObjectTypes() {
  try {
    const response = yield call(getObjectTypesAsync);
    if (response) {
      yield put(storeObjectTypes(response.data));
    }
  } catch (e) {
    //
  }
}

function* getRelatedObjectTypes() {
  try {
    const response = yield call(getRelatedObjectTypesAsync);
    if (response) {
      yield put(storeRelatedObjectTypes(response.data));
    }
  } catch (e) {
    //
  }
}

function* getFieldTypes() {
  try {
    const response = yield call(getFieldTypesAsync);
    if (response) {
      yield put(storeFieldTypes(response.data));
    }
  } catch (e) {
    //
  }
}

function* getCustomFieldChoicesLabelValue() {
  try {
    const response = yield call(getCustomFieldChoicesLabelValueAsync);
    if (response) {
      yield put(storeCustomFieldChoicesLabelValue(response.data));
    }
  } catch (e) {
    //
  }
}

export function* customFieldsSaga() {
  yield takeLatest(actions.REQUEST_CUSTOM_FIELDS, getCustomFields);
  yield takeLatest(actions.CREATE_UPDATE_CUSTOM_FIELDS, createUpdateCustomField);
  yield takeLatest(actions.DELETE_CUSTOM_FIELDS, deleteCustomField);
  yield takeLatest(actions.REQUEST_CUSTOM_FIELD_CHOICES, getCustomFieldChoices);
  yield takeLatest(
    actions.CREATE_UPDATE_CUSTOM_FIELD_CHOICES,
    createUpdateCustomFieldChoice
  );
  yield takeLatest(actions.DELETE_CUSTOM_FIELD_CHOICES, deleteCustomFieldChoice);
  yield takeLatest(actions.REQUEST_OBJECT_TYPES, getObjectTypes);
  yield takeLatest(actions.REQUEST_RELATED_OBJECT_TYPES, getRelatedObjectTypes);
  yield takeLatest(actions.REQUEST_FIELD_TYPES, getFieldTypes);
  yield takeLatest(
    actions.REQUEST_CUSTOM_FIELD_CHOICES_LABEL_VALUE,
    getCustomFieldChoicesLabelValue
  );
}
